module.exports = __webpack_public_path__ + "img/case-bj4.119f16bd.png";